import store from '@/state/store'
let fields = [
  {
    key: 'startTime',
    label: 'report.fields.startTime',
    header: 'startTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'stopTime',
    label: 'report.fields.endTime',
    header: 'stopTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: !store.getters['identity/hasAccess'](['report_stopped_new:read']),
    width: 20,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'latitude',
    label: 'report.fields.latitude',
    header: 'latitude',
    filter: false,
    width: 10,
  },
  {
    key: 'longitude',
    label: 'report.fields.longitude',
    header: 'longitude',
    filter: false,
    width: 10,
  },
  {
    key: 'address',
    label: 'report.fields.location',
    header: 'address',
    filter: false,
    width: 10,
  },
  {
    key: 'timeStopFormatted',
    label: 'report.fields.totalTimeTripStop',
    header: 'timeStopFormatted',
    filter: false,
    width: 10,
  },
]
let isAcc = false
if (store.getters['identity/hasAccess'](['report_stopped_new:read'])) {
  isAcc = true
  fields.splice(5, 0, {
    key: 'acc',
    label: 'report.object.acc',
    header: 'acc',
    filter: true,
    width: 10,
  })
}
if (store.getters['identity/hasAccess'](['summary_stopped_geofence_column:read'])) {
  fields.splice(isAcc ? 9 : 8, 0, {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  })
}
export default fields
